/**
 * Parâmetros de cor dos chips de categoria do modal "Ver detalhes".
 *
 * A cor sai de `stringToColor` (mesmo util das tags do CRM), então o mesmo
 * valor pinta igual em toda a plataforma. Saturação e luminosidade baixas
 * mantêm o chip legível sobre fundo claro; o alpha do fundo é o mesmo do
 * chip neutro do design system.
 */

export const CHIP_SATURATION = 45

export const CHIP_LIGHTNESS = 38

export const CHIP_BG_ALPHA = 0.14
